import axios from 'axios'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import { getToken,setToken,removeToken} from '@/utils/auth'

 // const baseURL = 'http://192.168.1.3:8899'
 // const baseURL = 'http://api.honorfly.mynatapp.cc'
 const baseURL = 'https://api.yufeiyunkeji.com'
//http://api.honorfly.mynatapp.cc
// const baseURL = process.env.NODE_ENV === 'development' ? 'https://api.yufeiyunkeji.com' : 'https://api.yufeiyunkeji.com'

// 创建一个axios实例
const service = axios.create({
  baseURL,
  // withCredentials: true,
  timeout: 50000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    let token = getToken()
    if (token) {
      // ['X-Token']是我这里自定义测试而塞到请求头中
      config.headers['Access-Token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    console.log("后台返回数据：============>:",response)
    const res = response.data
    // 与后端约定的错误码
    if (res.code !== 200) {
      if (res.code !== 405) {
        Toast.fail(res.message)
      }
      if (res.code === 405) {
        removeToken()
        // Toast.fail('会话过期，请关闭，重新进入！')
        window.location.reload()
      }
      return res
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    Toast.fail(error.message)
    return Promise.reject(error)
  }
)

export default service
